module.exports = __webpack_public_path__ + "static/media/dagdi_logo.7a320589.png";